import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
const _hoisted_1 = { class: "filterable-list__list-item-event" };
const _hoisted_2 = {
    key: 0,
    class: "filterable-list__list-item-time"
};
const _hoisted_3 = {
    key: 1,
    class: "filterable-list__list-item-address"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListItemContentTimeAddress',
    props: {
        itemTime: {},
        itemAddress: {}
    },
    setup(__props) {
        const { itemAddress, itemTime } = __props;
        const addressStr = itemAddress?.join(', ');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.itemTime)
                    ? (_openBlock(), _createElementBlock("time", _hoisted_2, _toDisplayString(_ctx.itemTime), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                (_ctx.itemAddress)
                    ? (_openBlock(), _createElementBlock("address", _hoisted_3, _toDisplayString(_unref(addressStr)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
